export default __webpack_public_path__ + "static/media/VJA-11.e60bc369.webp";